
import {
    ref
} from "vue";
export default {
    emits: ["done", "update:visible"],
    props: {
        // 弹窗是否打开
        visible: Boolean,
        // 修改回显的数据
        data: Object
    },
    data() {
        return {
            // 提交状态
            loading: false,
            // 是否是修改
            isUpdate: false,
            // 规则
            rules: {
                store_name: [{
                    required: true,
                    message: this.$t("share.require"),
                    trigger: "blur",
                }],
            }
        };
    },
    watch: {
        data() {
            if (this.data) {
                this.formState = Object.assign({}, this.data);
                this.isUpdate = true;
            } else {
                this.formState = {};
                this.isUpdate = false;
            }
            if (this.$refs.formRef) {
                this.$refs.formRef.clearValidate();
            }
        }
    },
    methods: {
        /* 更新visible */
        updateVisible(value) {
            this.$emit("update:visible", value);
        },
        /* 保存编辑 */
        save() {
            this.$refs.formRef
                .validate()
                .then(() => {
                    this.loading = true;
                    this.$http
                        .post("/user/store_account/update", this.formState)
                        .then(res => {
                            this.loading = false;
                            if (res.data.code === 0) {
                                this.$message.success(res.data.msg);
                                this.formState = {};
                                this.updateVisible(false);
                                this.$emit("done");
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        })
                        .catch(e => {
                            this.loading = false;
                            this.$message.error(e.message);
                        });
                })
                .catch(() => {});
        },
        onClose() {
            this.updateVisible(false);
        }
    },
    setup(props) {
        const formState = ref(Object.assign({}, props.data));
        return {
            formState
        };
    }
};
